<template>
	<mdb-container fluid>
		<mdb-row>
			<navbar/>
		</mdb-row>
	
		<mdb-row>
			<router-view/>
		</mdb-row>
		
		<mdb-row>
			<Footer/>
		</mdb-row>
		
	
	</mdb-container>
</template>

<script>
import Navbar from './components/Navbar'
import {mdbContainer, mdbRow } from 'mdbvue';
import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
		'Navbar' : Navbar,
		'Footer' : Footer,
		mdbContainer,
		mdbRow
  },
  watch: {
    '$route' (to, from) {
      document.title = to.meta.title || 'Your Website'
    }
  },
  created(){
    document.title = "Foxdown Construction"
  }
}
</script>

<style lang="scss">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.linkUnderlines a {
  color: #2a4a7a;
  text-decoration: none;
  display: inline-block;
  padding: 15px 20px;
  position: relative;
}

.linkUnderlines a:after {    
  background: none repeat scroll 0 0 transparent;
  bottom: 0;
  content: "";
  display: block;
  height: 2px;
  left: 50%;
  position: absolute;
  background: #2a4a7a;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0;
}

.linkUnderlines a:hover:after { 
  width: 100%; 
  left: 0; 
}

.foxDownBlue{
	color: #2a4a7a;
}

</style>
